import React from 'react';

type Props = {
  width?: number;
  height?: number;
  color?: string;
};

const IconCreditCardMinus: React.FC<Props> = ({
  width = 20,
  height = 20,
  color = '#3E454D',
}: Props) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M9.1665 14.3749H4.1665C2.85234 14.3749 2.2915 13.8141 2.2915 12.4999V8.12492H16.0415V8.33325C16.0415 8.67825 16.3215 8.95825 16.6665 8.95825C17.0115 8.95825 17.2915 8.67825 17.2915 8.33325V5.83325C17.2915 3.81825 16.1815 2.70825 14.1665 2.70825H4.1665C2.1515 2.70825 1.0415 3.81825 1.0415 5.83325V12.4999C1.0415 14.5149 2.1515 15.6249 4.1665 15.6249H9.1665C9.5115 15.6249 9.7915 15.3449 9.7915 14.9999C9.7915 14.6549 9.5115 14.3749 9.1665 14.3749ZM4.1665 3.95825H14.1665C15.4807 3.95825 16.0415 4.51909 16.0415 5.83325V6.87492H2.2915V5.83325C2.2915 4.51909 2.85234 3.95825 4.1665 3.95825ZM7.49984 11.0416C7.84484 11.0416 8.12484 11.3216 8.12484 11.6666C8.12484 12.0116 7.84484 12.2916 7.49984 12.2916H4.99984C4.65484 12.2916 4.37484 12.0116 4.37484 11.6666C4.37484 11.3216 4.65484 11.0416 4.99984 11.0416H7.49984ZM16.6665 14.1666C16.6665 14.5116 16.3865 14.7916 16.0415 14.7916H13.9582C13.6132 14.7916 13.3332 14.5116 13.3332 14.1666C13.3332 13.8216 13.6132 13.5416 13.9582 13.5416H16.0415C16.3865 13.5416 16.6665 13.8216 16.6665 14.1666ZM14.9998 10.2083C12.8173 10.2083 11.0415 11.9841 11.0415 14.1666C11.0415 16.3491 12.8173 18.1249 14.9998 18.1249C17.1823 18.1249 18.9582 16.3491 18.9582 14.1666C18.9582 11.9841 17.1823 10.2083 14.9998 10.2083ZM14.9998 16.8749C13.5065 16.8749 12.2915 15.6599 12.2915 14.1666C12.2915 12.6733 13.5065 11.4583 14.9998 11.4583C16.4932 11.4583 17.7082 12.6733 17.7082 14.1666C17.7082 15.6599 16.4932 16.8749 14.9998 16.8749Z" fill={color} />
  </svg>
);

export default IconCreditCardMinus;
